import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Tab } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import GeneralSettings from "./Fields/GeneralSettings";
import ErpSettings from "./Fields/ErpSettings";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import { ApiResponseType } from "../../../common/api/apiHelper";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import WhatsappSettings from "./Fields/WhatsappSettings";

type FieldProps ={
  erpParameters: any,
  parameters: any,
  vpList: any,
  divisionList: any,
  departmentList: any,
  contractsState: any
  firmWhatsappInfo: any
} 

export default function Fields({ erpParameters, parameters, vpList, divisionList, departmentList, contractsState, firmWhatsappInfo }: FieldProps) {

  const {firmInformations} = useRecoilValue(tenantState);

  const [tabIndex, setTabIndex] = useState<string>('1');
  // const [isErpEnable, setIsErpEnable] = useState<Boolean>(false);

  // useEffect(() => {
  //   isErpEnableHandle();
  // }, []);

  const handleTabChange = (event: any, newValue: string) => {
    setTabIndex(newValue);
  };

  // async function isErpEnableHandle() {

  //   let result: ApiResponseType;

  //   result = await commonNetwork.get(`/tenant/${firmInformations.firmPath}`);

  //   if (result.isSuccess) {
  //     if (result.data.isErp) {
  //       setIsErpEnable(true);
  //     } else {
  //       setIsErpEnable(false);
  //     }
  //   } else {
  //     toast.error("Firma Erp bilgisi alınamadı.")
  //   }
  // }

  return (
    <div>
      <Box sx={{ width: '100%', typography: '' }} className="pt-0 pb-10" >
        <TabContext value={tabIndex}>
          <Box sx={{borderBottom:1, borderColor: 'divider'}}>
            <TabList onChange={handleTabChange} aria-label="">
              <Tab label="Genel Ayarlar" value="1"/>
             <Tab disabled={firmInformations.isErp ? false : true} label="Erp Ayarları" value="2"/>
             {firmInformations.isWhatsapp && (
               <Tab label="Whatsapp Ayarları" value="3"/>
             )}
            </TabList>
          </Box>
          <TabPanel value="1" className="!p-0">
            <GeneralSettings
                vpList={vpList}
                parameters={parameters}
                contractsState={contractsState}
            />
          </TabPanel>
          <TabPanel value="2" className="!p-0">
            <ErpSettings
                erpParameters={erpParameters}
                parameters={parameters}
                divisionList={divisionList}
                departmentList={departmentList}
            />
          </TabPanel>
          <TabPanel value="3" className="!p-0">
            <WhatsappSettings firmWhatsappInfoParameters={firmWhatsappInfo} />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
}
